import React from 'react';
import { Table } from 'reactstrap';
import {
  PERCENT
} from "../../../../../config/constants/Campaign/campaign_constants";
import { FormattedMessage } from "react-intl";

function TableCouponDetails(props) {
  const { coupon, couponProducts, index } = props;

  if ( ! coupon || !couponProducts || !couponProducts.length) {
    return null;
  }

  return <tr key={ index }>
    <td colSpan="8">
      <div className="campaign-coupon-details-scroll">
        <Table className="campaign-coupon-details-table">
          <thead>
            <tr>
              <th><FormattedMessage id="fields.campaignManagement.productList.name" /></th>
              <th><FormattedMessage id="fields.campaignManagement.productList.package_name" /></th>
              <th><FormattedMessage id="fields.campaignManagement.productList.discount_value" /></th>
              <th><FormattedMessage id="fields.campaignManagement.productList.usage" /></th>
            </tr>
          </thead>
          <tbody>
          {
            couponProducts.map(function(coupon_product, index) {
              return (<tr key={ index }>
                {
                  <>
                    <td>{ coupon_product.product_group_name }</td>
                    <td>{ coupon_product.product_name }</td>
                    <td>
                      { coupon_product.discount_type === PERCENT ? `${coupon_product.value}%` : coupon_product.value }
                    </td>
                    <td>
                      { coupon_product.usage }
                    </td>
                  </>
                }
              </tr>);
            })
          }
          </tbody>
        </Table>
      </div>
    </td>
  </tr>;
}

export { TableCouponDetails };
